export default {
  STATUS_EARLY_ACCESS: 'early_access',
  STATUS_EXCLUSIVE: 'exclusive',
};
